import Swiper from 'swiper';

export function modalGallery() {
    const pictures = document.querySelectorAll('.js-galleryOpen');
    const galleryWrapper = document.querySelector('.js-galleryWrapper');
    const activeSlideBlock = document.querySelector('.js-galleryActiveSlide');
    const slidesLengthBlock = document.querySelector('.js-gallerySlidesLength');

    slidesLengthBlock.textContent = pictures.length;

    pictures.forEach( (item, index) => {
        let src = item.dataset.image ? item.dataset.image : item.querySelector('img').src,
            slide = document.createElement('div'),
            img = document.createElement('img');

        item.dataset.index = index;

        slide.classList.add('modal-slide');
        slide.setAttribute('am-slide', 'modal');
        img.src = src;
        slide.appendChild(img);
        galleryWrapper.appendChild(slide);

    });

    let sliderModal = new Swiper('.modal-slider', {
        containerModifierClass: 'modal-slider',
        wrapperClass: 'modal-slider__wrapper',
        slideClass: 'modal-slide',
        slideActiveClass: 'is-active',
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        navigation: {
            nextEl: '.modal-slider-button-next',
            prevEl: '.modal-slider-button-prev',
        },
    });

    sliderModal.on('slideChange', () => {
        activeSlideBlock.textContent = sliderModal.activeIndex + 1;
    });


    pictures.forEach( item => {
        let modalTitle = item.closest('[data-title]').dataset.title;
        document.querySelector('.js-galleryModalTitle').textContent = modalTitle;

        item.addEventListener('click', () => {
            sliderModal.update();
            sliderModal.slideTo(item.dataset.index, 0);
        });
    })
}